import { render, staticRenderFns } from "./groupRelation.vue?vue&type=template&id=5f35a764"
import script from "./groupRelation.vue?vue&type=script&lang=js"
export * from "./groupRelation.vue?vue&type=script&lang=js"
import style0 from "./groupRelation.vue?vue&type=style&index=0&id=5f35a764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports